import { faCommentsAlt } from "@jewlr/pro-light-svg-icons/faCommentsAlt"
import { faChevronRight } from "@jewlr/pro-regular-svg-icons/faChevronRight"
import {
  Box,
  Button,
  Flex,
  FontAwesomeIcon,
  Typography,
} from "@jewlr/storybook/core"
import PropTypes from "prop-types"
import { Link } from "react-router-dom"
import styled from "styled-components"

import withAuth from "hoc/account/with-auth"

const Container = styled(Box)`
  border: 1px solid ${(props) => props.theme.colors.grey[20]};
  box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.1);
  margin-bottom: 32px;
  padding: 16px;
  width: 100%;
  ${(props) => props.theme.mediaQueries.tablet`
    border: none;
    box-shadow: none;
    margin-bottom: 0;
    padding: 0;
    width: auto;
  `}
`

const CTA = styled(Button)`
  border: 1px solid ${(props) => props.theme.colors.primary};
  border-radius: 5px;
  color: ${(props) => props.theme.colors.primary};
  font-size: 16px;
  font-weight: 500;
  height: 44px;
  line-height: 16px;
  width: 212px;
  &:focus,
  &:hover {
    color: ${(props) => props.theme.colors.primary};
  }
`

const Method = styled(Typography)`
  font-size: 16px;
  font-weight: 300;
  letter-spacing: -0.02em;
  line-height: 22px;

  a {
    color: ${(props) => props.theme.colors.primary};
    font-weight: 500;
  }
`

const Contact = ({ loggedIn, toAuthenticate }) => (
  <Flex
    alignItems={{ _: "center", tablet: "flex-start" }}
    flexDirection={{ _: "column", tablet: "row" }}
    justifyContent="space-between"
    pt={2}
  >
    <Container>
      <Flex alignItems="center" mb={2}>
        <FontAwesomeIcon fontSize="20px" icon={faCommentsAlt} mr={1} />
        <Typography
          as="h2"
          fontSize={{ _: "18px", tablet: "26px" }}
          fontWeight={{ _: "700", tablet: "500" }}
          lineHeight={{ tablet: "30px" }}
        >
          Need Help?
        </Typography>
      </Flex>
      <Box>
        <Method mb={1}>
          Phone:{" "}
          <a
            href={`tel:${sl.config.customer_service_toll_free}`}
            rel="nofollow"
          >
            {sl.config.customer_service_toll_free}
          </a>
        </Method>
        <Method mb={1}>
          Email:{" "}
          <a
            href={`mailto:${sl.config.customer_service_email}`}
            rel="noreferrer"
            target="_blank"
          >
            {sl.config.customer_service_email}
          </a>
        </Method>
        <Method>
          General Questions:{" "}
          <Link data-lc="contact" to="/helpdesk">
            Read Our FAQs
          </Link>
        </Method>
      </Box>
    </Container>
    {loggedIn ? (
      <CTA data-lc="contact" forwardedAs={Link} to="/">
        Continue Shopping
        <FontAwesomeIcon fontSize="8px" icon={faChevronRight} ml="6px" />
      </CTA>
    ) : (
      <CTA onClick={toAuthenticate}>Sign In</CTA>
    )}
  </Flex>
)

Contact.propTypes = {
  loggedIn: PropTypes.bool,
  toAuthenticate: PropTypes.func,
}

export default withAuth(Contact)
